import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, TextField, Button } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
// ----------------------------------------------------------------------
import request from '../../../services/Request';

import moment from 'moment';
import Swal from 'sweetalert2';
import MaterialTable from 'material-table';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(-5.6),
    marginRight: theme.spacing(40),
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

export default function UserActivityLog(props) {
  const user = JSON.parse(localStorage.getItem('user'));
  var date = new Date();
  const classes = useStyles();
  const [groups, setGroups] = useState([]);
  const [groupV, setgroupV] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reflesh, setReflesh] = useState(false);
  const [sw, setsw] = useState(false);
  const [originalData, setOriginalData] = useState([]);

  const [data, setData] = useState([]);

  const [startDate, setStartDate] = useState(new Date(date.getFullYear(), date.getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date());

  const columns = [
    {
      title: 'Timestamp',
      field: 'timestamp',
      type: 'datetime', // You can use 'datetime' for date-time fields
      render: (rowData) => new Date(rowData.timestamp).toLocaleString(), // Custom render function
    },
    // {
    //   title: 'Action Type', // The column title
    //   field: 'actionType', // The corresponding field in your data
    //   type: 'string', // The type of data (optional)
    // },
    {
      title: 'Details',
      field: 'details',
      type: 'string',
    },
    {
      title: 'Name', // The column title
      field: 'user', // The key in the data
      render: (rowData) => `${rowData.user.firstname} ${rowData.user.lastname}`, // Custom render function to display full name
    },
    {
      title: 'Email',
      field: 'user.email', // Direct mapping to user's email
      render: (rowData) => rowData.user.email,
    },
  ];

  useEffect(() => {
    let isCancelled = false;
    setLoading(false);
    //getAllEmployees
    async function getAllAdmins() {
      await request({
        method: 'get',
        url: `/users/getAllEmployees`,
      }).then((res) => {
        if (!isCancelled) {
          // console.log('res.data', res.data);
          if (res.data.length > 0) {
            let array = [{ email: 'All', groupname: 'All User' }, ...res.data];
            setGroups(array);
            setLoading(true);
          }
        }
      });
    }

    getAllAdmins();

    return () => {
      isCancelled = true;
    };
  }, [reflesh]);

  const handleStartDate = (e) => {
    setStartDate(e);
  };

  const handleEndDate = (e) => {
    setEndDate(e);
  };

  const handleChange = async () => {
    setLoading(false);
    // console.log(groupV);
    request({
      method: 'post',
      url: '/userLogs/getAdminActivityLog',
      data: {
        // group: groupV,
        startDate: startDate,
        endDate: endDate,
        email: groupV.email,
      },
    })
      .then((res) => {
        console.log('ALL logs', res.data);
        setOriginalData(res.data);
        //filterData if user.email includes @dba
        setData(res.data.filter((e) => !e.user?.email.includes('@dba.com')));
      })
      .catch(() => {})
      .finally(() => {
        setLoading(true);
        setReflesh(!reflesh);
      });
  };

  return (
    <div>
      <Grid container style={{ paddingLeft: '40px', marginTop: '30px' }} alignItems="center">
        <Grid xs={4} item container justifyContent="flex-start">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              className={classes.formControl}
              value={startDate}
              onChange={(e) => handleStartDate(e)}
              label="Select start date"
              format="MM/dd/yyyy"
              margin="normal"
              id="date-picker-start"
            />
            <KeyboardDatePicker
              className={classes.formControl}
              value={endDate}
              onChange={(e) => handleEndDate(e)}
              label="Select end date"
              format="MM/dd/yyyy"
              margin="normal"
              id="date-picker-end"
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid
          xs={4}
          item
          container
          justifyContent="flex-start"
          alignContent="center"
          alignItems="center"
        >
          <Autocomplete
            value={groupV}
            options={groups}
            onChange={(event, value) => {
              setgroupV(value);
            }}
            getOptionSelected={(option, value) => option._id === value._id}
            getOptionLabel={(option) => (option?.groupname ? option?.groupname : '')}
            fullWidth
            renderInput={(params) => <TextField {...params} variant="outlined" label="Customers" />}
          />
        </Grid>
        <Grid item xs={1} style={{ marginLeft: '15px' }}>
          {!props.compare && (
            <Button
              style={{ height: '40px' }}
              onClick={handleChange}
              disabled={!groupV?.email || !loading}
              variant="contained"
              color="primary"
            >
              Submit
            </Button>
          )}
        </Grid>
        <Grid item xs={1} style={{ marginLeft: '15px' }}>
          <Button
            style={{ height: '40px', width: '150px' }}
            onClick={() => {
              setsw(!sw);
            }}
            variant="contained"
            color="primary"
          >
            {sw ? 'Hide  DBA' : 'Show  DBA'}
          </Button>
        </Grid>
      </Grid>
      <MaterialTable
        style={{ marginTop: '40px' }}
        columns={columns}
        data={sw ? originalData : data}
        title={''}
        options={{
          actionsColumnIndex: -1,
          pageSize: 100,
          pageSizeOptions: [100, 200, 500, 1000, 2000],
        }}
      />
    </div>
  );
}
